export default "__VITE_ASSET__CHbDomQ8__"